import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, RefreshCw, Gamepad2, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { verifyDiscordRole } from '../lib/api';

const Pendente = () => {
  const { user, logout } = useAuth();
  const [checking, setChecking] = useState(false);
  const [lastCheck, setLastCheck] = useState(null);

  if (!user) {
    return null; // Isso não deve acontecer devido ao ProtectedRoute, mas por segurança
  }

  const handleCheckStatus = async () => {
    try {
      setChecking(true);
      await verifyDiscordRole(user.discord_id);
      // Após verificar, recarregar a página para atualizar o status do usuário
      window.location.reload();
    } catch (error) {
      console.error('Erro ao verificar status:', error);
    } finally {
      setChecking(false);
      setLastCheck(new Date());
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-purple-950 text-white flex flex-col">
      {/* Header */}
      <header className="border-b border-white/10 bg-black/40 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-8 py-4 flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-cyan-400 to-fuchsia-600 rounded-full blur opacity-75"></div>
              <Gamepad2 className="relative w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-black tracking-widest italic">NEXUS</h1>
          </div>
          
          <button 
            onClick={logout}
            className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-sm transition-all"
          >
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>
      </header>
      
      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-8">
        <div className="max-w-2xl w-full bg-black/60 backdrop-blur-xl border border-white/10 rounded-sm p-8 text-center">
          <div className="mb-6 mx-auto w-16 h-16 flex items-center justify-center bg-yellow-500/20 rounded-full">
            <AlertCircle size={32} className="text-yellow-400" />
          </div>
          
          <h2 className="text-3xl font-bold mb-4">Acesso Pendente</h2>
          
          <div className="mb-8 space-y-4">
            <p className="text-gray-300">
              Olá, <span className="font-bold text-white">{user.discord_username}</span>!
            </p>
            <p className="text-gray-300">
              Seu acesso à plataforma está pendente de aprovação. Um administrador precisa aprovar sua conta manualmente.
            </p>
          </div>
          
          <div className="bg-white/5 border border-white/10 rounded-sm p-4 mb-8">
            <h3 className="font-bold mb-2">Como obter acesso:</h3>
            <ol className="text-left text-gray-300 space-y-2 pl-6 list-decimal">
              <li>Aguarde a aprovação de um administrador</li>
              <li>Após ser aprovado, você receberá acesso completo à plataforma</li>
              <li>Você pode clicar em "Verificar Status" para atualizar seu status</li>
            </ol>
          </div>
          
          <button
            onClick={handleCheckStatus}
            disabled={checking}
            className="w-full py-4 bg-gradient-to-r from-cyan-500 to-fuchsia-600 hover:shadow-[0_0_30px_rgba(34,211,238,0.5)] rounded-sm font-bold flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {checking ? (
              <>
                <RefreshCw size={20} className="animate-spin" />
                <span>Verificando...</span>
              </>
            ) : (
              <>
                <RefreshCw size={20} className="group-hover:rotate-180 transition-transform duration-500" />
                <span>Verificar Status</span>
              </>
            )}
          </button>
          
          {lastCheck && (
            <p className="mt-4 text-xs text-gray-500">
              Última verificação: {lastCheck.toLocaleTimeString()}
            </p>
          )}
        </div>
      </main>
      
      {/* Footer */}
      <footer className="border-t border-white/10 bg-black/40 backdrop-blur-md py-4">
        <div className="max-w-7xl mx-auto px-8 text-center text-sm text-gray-500">
          <p>
            Precisa de ajuda? Entre em contato com um administrador no Discord.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Pendente;